import accountIcon from "./assets/account-favicon.svg";
import copIcon from "./assets/cop-favicon.svg";
import dashboardIcon from "./assets/dashboard-favicon.png";
import engageIcon from "./assets/engage-favicon.svg";
import { getPortalConfig } from "./config/portalConfig";
import { getVendorConfig } from "./portals/messagemedia/vendorConfig";

function changeFavicon(src: string) {
  const documentHead =
    document.head || document.getElementsByTagName("head")[0];
  const link = document.createElement("link");
  link.id = "dynamic-favicon";
  link.rel = "shortcut icon";
  link.href = src;
  documentHead.appendChild(link);
}

const removeFavicon = () => {
  const links = document.getElementsByTagName("link");
  for (const link of Array.from(links)) {
    if (link?.getAttribute("rel") === "icon") {
      document.head.removeChild(link);
    }
  }
};

const changeMmFavicon = (favicon?: string) => {
  if (favicon === undefined) return;
  removeFavicon();
  const link: HTMLLinkElement =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = `/hub-container/latest/static/themes/favicon/${favicon}`;
  document.head.appendChild(link);
};

export const setFaviconAndTitle = () => {
  const configName = getPortalConfig("configName");
  if (!configName) {
    return;
  }

  const [entry] = configName.split(".");

  switch (entry) {
    case "engage":
      document.title = "Engage";
      changeFavicon(engageIcon);
      break;
    case "dashboard":
      document.title = "Sinch Customer Dashboard";
      changeFavicon(dashboardIcon);
      break;
    case "cop":
      document.title = "COP";
      changeFavicon(copIcon);
      // TODO: add icon
      break;
    case "mm":
      changeMmFavicon(getVendorConfig().favicon);
      break;
    case "account":
    case "accountAdmin":
      changeFavicon(accountIcon);
      break;
    default:
      break;
  }
};
